import { EjariProperty } from "./Entity";

interface PropertyProcessor {
	( property: EjariProperty ): EjariProperty;
}

interface IEjariHooks {
	addPropertyProcessor( id: string, processor: PropertyProcessor ): void;

	removePropertyProcessor( id: string ): void;
}

class EjariHooks implements IEjariHooks {
	propertyProcessors: { [ key: string ]: PropertyProcessor } = {};

	addPropertyProcessor( id: string, processor: PropertyProcessor ): void {
		this.propertyProcessors[ id ] = processor;
	}

	removePropertyProcessor( id: string ): void {
		delete this.propertyProcessors[ id ];
	}

}

const hooks = new EjariHooks();
export default hooks;
